module.exports = __webpack_public_path__ + "assets/img/zzsl1.83e814f0.png";